<template>
  <button
    class="btn btn-primary btn-lg save-next"
    :disabled="disabled"
    @click="submit"
  >
    <translation :text="lang.get('buttons.pay-enter')" />
  </button>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  inject: ['lang'],
  props: {
    label: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapGetters('entryForm', ['isValid', 'isSaveable', 'isLoaded']),
    ...mapState('entryForm', ['uploadInProgress']),
    ...mapState('entryFormConfiguration', ['configurationMode']),
    disabled() {
      return (
        this.configurationMode ||
        this.uploadInProgress ||
        !this.isValid ||
        !this.isSaveable ||
        !this.isLoaded
      );
    }
  },
  methods: {
    ...mapActions('entryFormApi', { submit: 'saveAndPay' })
  }
};
</script>
